import axios from 'axios';

// Default to the relative `/api` path so requests are proxied by the frontend
// server (development proxy or nginx) to the backend. Production builds will
// use `REACT_APP_API_BASE` (set in the deploy workflow) when present.
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || '/api'
});

export default instance;
